import { db } from "../firebase";
import Firebase from "firebase";


// Example delete
export function exampleDeleteFunction(doc_id_1, doc_id_2,  callback) {

  let docRef = db.collection("example").doc(doc_id_1).collection("example").doc(doc_id_2)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteExerciseAurum(doc_id,  callback) {

  let docRef = db.collection("exercises").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteProgramAurum(doc_id,  callback) {

  let docRef = db.collection("programs").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteProgramWorkoutAurum(workoutID, doc_id,  callback) {

  let docRef = db.collection("programs").doc(doc_id).collection('workouts').doc(workoutID)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteProgramWorkoutCoach(uid, programID, workoutID, callback) {

  let docRef = db.collection("coaches").doc(uid).collection("programs").doc(programID).collection('workouts').doc(workoutID)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteExerciseCoach(uid, doc_id,  callback) {

  let docRef = db.collection("coaches").doc(uid).collection("exercises").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteProgramCoach(uid, doc_id,  callback) {

  let docRef = db.collection("coaches").doc(uid).collection("programs").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteWorkoutAurum(doc_id,  callback) {

  let docRef = db.collection("workouts").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteWorkoutCoach(uid, doc_id,  callback) {

  let docRef = db.collection("coaches").doc(uid).collection("workouts").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteMealplanAurum(doc_id,  callback) {

  let docRef = db.collection("mealplans").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

export function deleteMealplanCoach(uid, doc_id,  callback) {

  let docRef = db.collection("coaches").doc(uid).collection("mealplans").doc(doc_id)

  docRef.delete().then(() => {
    callback()
  })
}

// delete client from dashboard
export function deleteClient(client_id,  callback) {
  // debugger
  let docRef = db.collection("clients").doc(client_id)

  docRef.delete().then(() => {
    // debugger
    callback()
    console.log("client are deleted succesfully")
  }).catch((err)=>{
    // debugger
    console.log("client are not deleted ",err.message)

  })
}
//delete pending clients
export function deletePending(userEmail, callback) {
  console.log('---->>>>Delete: deletePending');
  let docRef = db.collection('pending_clients');
  docRef
    .where('client_email', '==', userEmail)
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        doc.ref.delete().then(function () {
          callback();
        });
      });
    });
}



export function deleteFormItemAurum(doc_id, sub_doc_id, content, callback) {

  let docRef

  if(sub_doc_id){
    docRef = db.collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id)
  }else{
    docRef = db.collection("forms").doc(doc_id)
  }
  docRef.set({form: Firebase.firestore.FieldValue.arrayRemove(content.item)}, {merge: true}).then((result) => {
    callback(result)
  })
}

export function deleteFormItemCoach(uid, doc_id, sub_doc_id, content, callback) {

  let docRef

  if(sub_doc_id){
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id)
  }else{
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id)
  }
  docRef.set({form: Firebase.firestore.FieldValue.arrayRemove(content.item)}, {merge: true}).then((result) => {
    callback(result)
  })
}

// delete workout client for a specific day
export const deleteDailyWorkoutCLient = (workout, client_id, time, callback) => {
  let docRef = db.collection("clients").doc(client_id).collection("workouts").doc(time)//.collection("workouts").doc(workout_id);
  console.log(workout)

  // TODO/ FIND CORRECT SUPERSET AND EXERCISE AND DELETE
  // docRef.set({exercises: Firebase.firestore.FieldValue.arrayRemove(workout)}, {merge: true}).then((result) => {
  //   callback(result)
  // })
}

// delete meal item clinet for a specific day
export const deleteDailyMealItemClient = (client_id, time, meal, callback) => {
  let docRef = db.collection("clients").doc(client_id).collection("mealplans").doc(time);
//   .whereField('plans.food.name', '==', meal.item.name)

  //get complete item
  /*let completeItem = {};
  docRef.onSnapshot((doc) => {
    console.log(doc)
    if(doc.exists){
      let _push = {}; _push = doc.data(); _push.id = doc.id;
      completeItem = _push;
      console.log(completeItem.plan)
      let test = completeItem.plan.find(element => element.food.name === meal.item.name);
      console.log(test)

    }
  });*/
}

export const deleteAppointment = (uid, id, type, time, callback) => {
  let docRef = db.collection("coaches").doc(uid).collection("calendar").doc(time).collection(type).doc(id)

  docRef.delete().then(() => {
    callback()
  })
}